<template lang="pug">
  .order
    .order__content(v-if="order.tickets && order.tickets.length")
      .order-picture
        label {{order.tickets.length}}
        picture
          img(:src="order.tickets[0].performance.image['170x240']")
      .order-description
        .order-title {{order.tickets[0].session.timeSpending | moment('DD MMMM')}}
          | &nbsp;/&nbsp;{{order.tickets[0].performance.name}}
        .line(v-if="order.status == 1") Номер:&nbsp;
          span.semi-strong {{order.code}}
        .line Мероприятие: {{order.tickets[0].performance.name}}
        .line Дата: {{order.tickets[0].session.timeSpending | moment('DD MMMM YYYY HH:mm')}}
        .line Место проведения: {{order.tickets[0].session.object.name}}
        .desc-tickets(:id="order.id")
          template(v-for="ticket in order.tickets")
            ticket(:ticket="ticket", :orderId="order.id", :external="order.isFromExternal",
              @update="update()")
        .desc-tickets(:id="order.id + 'items'")
          template(v-for="item in order.items")
            item(:item="item")
        .desc-buttons
          router-link.btn(v-if="order.status == 0 && !order.isFromExternal",
            :to="{ name: 'payment', params: { id: order.id } }") Оплатить
          button.btn(v-if="order.status == 1 && !order.hasObjectInfokiok && !order.isFromExternal",
            @click="printOrder(order.id, 'download')") Скачать
          button.btn(v-if="order.status == 1 && !order.hasObjectInfokiok && !order.isFromExternal",
            @click="printOrder(order.id, 'print')") Рапечатать
          button.btn.button_primary-outline(@click="openTickets(order.id)"
            ) Билеты ({{ order.tickets.length }})
          button.btn.button_primary-outline(v-if="order.items.length",
            @click="openTickets(order.id + 'items')") Товары ({{ order.items.length }})

    .order__content(v-if="order.services && order.services.length")
      .order-picture
        label {{order.services.length}}
        picture
          img(:src="order.services[0].service.performance.image['170x240']")
      .order-description
        .order-title {{order.services[0].service.performance.name}}
        .line Номер:&nbsp;
          span.semi-strong {{order.code}}
        .line Услуга: {{order.services[0].service.performance.name}}
        .line Срок действия, до: {{order.expired_at| moment('DD MMMM YYYY HH:mm')}}
        .desc-tickets
          //- TODO: services
          //- ticket(v-for="service in order.services", :ticket="service", :order="order")
        .desc-buttons
          button.btn(v-if="order.status == 0") Оплатить
          button.btn(v-if="order.status == 1 && order.hasObjectInfokiok && !order.isFromExternal",
            @click="printOrder(order.id, 'download')") Скачать
          button.btn(v-if="order.status == 1 && order.hasObjectInfokiok && !order.isFromExternal",
            @click="printOrder(order.id, 'print')") Рапечатать
          button.btn.button_primary-outline Услуги ({{order.services.length}})

    .order__content(v-if="order.trains && order.trains.length")
      .order-picture
        label {{order.trains.length}}
        picture.trains
          img(src="~@/assets/img/train.jpg")
      .order-description
        .order-title Ж/Д билеты. {{order.trains[0].from}} - {{order.trains[0].to}}
        .line Номер:&nbsp;
          span.semi-strong {{order.code}}
        .line Дата и время отправления:&nbsp;
          | {{order.trains[0].date}}, {{order.trains[0].departureTimeInformation}}
        .line Перевозчик: {{order.trains[0].carrierName}}
        .line Номер поезда: {{order.trains[0].trainNumber}}
        .desc-tickets(:id="order.id")
          template(v-for="train in order.trains")
            train-ticket(:ticket="train", :orderId="order.id", :external="order.isFromExternal",
            @update="update()")
        .desc-buttons
          router-link.btn(v-if="order.status == 0",
            :to="{name: 'payment', params: {id: order.id}}") Оплатить
          button.btn(v-if="order.status == 1 && !order.hasObjectInfokiok && !order.isFromExternal",
            @click="printOrder(order.id, 'download')") Скачать
          button.btn(v-if="order.status == 1 && !order.hasObjectInfokiok && !order.isFromExternal",
            @click="printOrder(order.id, 'print')") Рапечатать
          button.btn.button_primary-outline(@click="openTickets(order.id)")
            | Билеты ({{order.trains.length}})
          button.btn.button_white(v-if="!order.isFromExternal && order.status > 0",
            @click="receipt(order.id)") Чеки

    .order__status
      template(v-if="order.isFromExternal")
        .order-amount(v-if="order.total_amount_int > 0") {{order.total_amount}}
          span.currency &nbsp;руб.
        .order-discount(v-if="order.discount") Скидка {{order.discount / 100}} руб.
        .order-status.payed
          i
          | Привязан
        .order-msg
          | Билеты приобретен на стороннем ресурсе и привязан в личном кабинете
      template(
      v-else-if="order.tickets[0] && order.tickets[0].session.timeSpending > $moment().unix()")
        template(v-if="order.status == 3")
          .order-amount(v-if="order.total_amount_int > 0") {{order.total_amount}}
            span.currency &nbsp;руб.
          .order-discount(v-if="order.discount") Скидка {{order.discount / 100}} руб.
          .order-status.booked
            i
            | В процессе возврата
          .order-msg
            | Заказ находится в процессе возврата
        template(v-if="order.status == 1")
          .order-amount(v-if="order.total_amount_int > 0") {{order.total_amount}}
            span.currency &nbsp;руб.
          .order-discount(v-if="order.discount") Скидка {{order.discount / 100}} руб.
          .order-status.payed
            i
            | Оплачено
          // .order-msg(v-if="order.hasObjectInfokiok")
            | Билеты можно распечатать в кассах самообслуживания
          .order-msg(v-if="order.hasObjectWallet == 0")
            | Для прохода на мероприятие распечатайте билеты
          .order-msg(v-if="order.hasObjectWallet == 1")
            | Распечатайте билеты, или предоставьте на экране электронного носителя
          a.order-cancel(@click="returnOrder", href="#")
            i
            | Отменить заказ
        template(v-if="order.status == 0")
          .order-amount(v-if="order.total_amount_int > 0") {{order.total_amount}} руб.
          .order-status.booked(v-if="order.type == 6") Забронировано
          .order-status.no-payed(v-else)
            i
            | Не оплачено
          .order-msg
            | Заказ необходимо оплатить
            | до {{order.expired_at | moment('DD MMM YYYY HH:mm')}}
            | на сайте, в кассе, или терминале самообслуживания
          a.order-cancel(@click="showCancel=true", href="#")
            i
            | Отменить бронирование
      template(
        v-else-if="order.trains[0] && $moment(order.trains[0].date).unix() > $moment().unix()")
        template(v-if="order.status == 3")
          .order-amount(v-if="order.total_amount_int > 0") {{order.total_amount}}
            span.currency &nbsp;руб.
          .order-discount(v-if="order.discount") Скидка {{order.discount / 100}} руб.
          .order-status.booked
            i
            | В процессе возврата
          .order-msg Заказ находится в процессе возврата
        template(v-if="order.status == 1")
          .order-amount(v-if="order.total_amount_int > 0") {{order.total_amount}}
            span.currency &nbsp;руб.
          .order-discount(v-if="order.discount") Скидка {{order.discount / 100}} руб.
          .order-status.payed
            i
            | Оплачено
          .order-msg(v-if="order.hasObjectInfokiok")
            | Билеты можно распечатать в кассах самообслуживания
          .order-msg(v-if="!order.hasObjectInfokiok")
            template(v-if="order.trains[0].remoteCheckIn") При посадке иметь при себе документ,
              | &nbsp;удостоверяющий личность
            template(v-else) Билеты можно получить в кассе до отправления
          template(v-if="order.trains[0].remoteCheckInAvailable")
            a.order-cancel(v-if="order.trains[0].remoteCheckIn", @click="removeEReg=true", href="#")
              i
              | Отменить электронную регистрацию
            a.order-cancel(v-else, @click="addEReg=true", href="#")
              .plus +
              | Оформить электронную регистрацию
          template
            a.order-cancel(@click="returnOrder", href="#")
              i
              | Отменить заказ
        template(v-if="order.status == 0")
          .order-amount(v-if="order.total_amount_int > 0") {{order.total_amount}} руб.
          .order-status.booked(v-if="order.type == 6") Забронировано
          .order-status.no-payed(v-else)
            i
            | Не оплачено
          .order-msg
            | Заказ необходимо оплатить
            | до {{order.expired_at | moment('DD MMM YYYY HH:mm')}}
            | на сайте, в кассе, или терминале самообслуживания
          a.order-cancel(@click="showCancel=true", href="#")
            i
            | Отменить бронирование
      template(v-else)
        template(v-if="order.status == 1")
          .order-amount(v-if="order.total_amount_int > 0") {{order.total_amount}}
            span.currency &nbsp;руб.
          .order-status.archive
            i
            | Архив
          .order-msg Билет не действителен

    popup-cancel(v-if="showCancel", :orderId="order.id", @close="showCancel = false",
      @onCancel="update()")

    popup-return(v-if="showReturn", :orderId="order.id", @close="showReturn = false",
      @onReturn="update()")

    popup-er(v-if="removeEReg", :orderId="order.id", :status="0", @close="removeEReg = false",
      @onCancel="update()")

    popup-er(v-if="addEReg", :orderId="order.id", :status="1", @close="addEReg = false",
      @onCancel="update()")

</template>

<script>
import config from '@/api/config';
import Ticket from '@/components/Ticket.vue';
import TrainTicket from '@/components/TrainTicket.vue';
import Item from '@/components/Item.vue';
import popupEr from '@/components/popups/EReg.vue';
import popupCancel from '@/components/popups/cancel.vue';
import popupReturn from '@/components/popups/return.vue';

export default {
  components: {
    Ticket,
    Item,
    TrainTicket,
    popupCancel,
    popupReturn,
    popupEr,
  },
  data() {
    return {
      showReturn: false,
      showCancel: false,
      addEReg: false,
      removeEReg: false,
    };
  },
  props: ['order'],
  computed: {
    cabinet() {
      if (this.$store.state.cabinet) {
        return this.$store.state.cabinet;
      }
      return null;
    },
  },
  methods: {
    openTickets(id) {
      const el = document.getElementById(id);
      if (el.classList.contains('show')) {
        el.classList.remove('show');
        return;
      }
      el.classList.add('show');
    },
    update() {
      this.$emit('update');
      this.showCancel = false;
    },
    printOrder(id, action) {
      if (this.cabinet && this.cabinet.profile) {
        const token = this.cabinet.profile.downloadToken;
        window.open(this.downloadUrl(id, token, action));
      }
    },
    downloadUrl(id, token, action) {
      return `${config.baseUrl}/api/v2/users/me/orders/${id}/${action}?t=${token}&lang=ru`;
    },
    receipt(id = -1) {
      const { cabinet: { profile: { downloadToken = undefined } = {} } = {} } = this;
      if (id <= 0 || !downloadToken) {
        return;
      }
      window.open(`${config.baseUrl}/api/v2/users/me/orders/${id}/receipt?t=${downloadToken}`);
    },

    returnOrder() {
      this.showReturn = true;
    },
  },
};
</script>

<style lang="scss">
.order{
  width: 100%;
  border-top: 1px solid #ddd;
  display: flex;
  &__content {
    width: 750px;
    display: flex;
    padding: 1.5rem 0;
    .order-picture {
      width: 170px;
      position: relative;
      label{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1.75rem;
        height: 2rem;
        font-weight: 600;
        font-size: 12px;
        background-color: #ffde00;
        top: 0;
        right: 1rem;
        position: absolute;
        border-bottom-left-radius: .125rem;
        border-bottom-right-radius: .125rem;
      }
      picture{
        // 123
        // &.trains{
        //   img {
        //     min-width: 170px;
        //     min-height: 170px;
        //     max-width: 170px;
        //     max-height: 170px;
        //     border-radius: .125rem;
        //   }
        // }
        img {
          min-width: 170px;
          min-height: 240px;
          max-width: 170px;
          max-height: 240px;
          border-radius: .125rem;
        }
      }
    }
    .order-description{
      width: 100%;
      padding: .5rem 1.5rem;
      .order-title{
        font-size: 16px;
        font-weight: 600;
        padding-bottom: 1rem;
      }
      .line{
        padding-bottom: .75rem;
        font-size: 12px;
        font-weight: 500;
        .semi-strong{
          font-weight: 700;
        }
      }
      .desc-tickets{
        margin-top: 1rem;
        max-height: 0px;
        overflow: hidden;
        -webkit-transition:max-height 0.4s linear;
        -moz-transition:max-height 0.4s linear;
        transition:max-height 0.4s linear;
        &.show{
          border-bottom: 1px dotted #ddd;
          overflow: scroll;
          max-height: 100%;
        }
      }
      .desc-buttons{
        padding-top: 1rem;
        .btn {
          margin-right: 1rem;
        }
      }
    }
  }
  &__status{
    border-left: 1px solid #ddd;
    padding: 40px 35px;
    max-width: 250px;
    width: 100%;
    .order-amount{
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 1rem;
      .currency{
        font-weight: 500;
        font-size: 16px;
      }
    }
    .order-status{
      font-size: 11px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 1rem;
      color: #fff;
      width: 100%;
      height: 2rem;
      border-radius: 1rem;
      &.payed{
        i{
          background: url('../../../../common/assets/img/status_success.png') no-repeat #0c9;
          width: 16px;
          height: 12px;
        }
        background-color: #0c9;
      }
      &.archive{
        i{
          background: url('../../../../common/assets/img/status_success.png') no-repeat #aaa;
          width: 16px;
          height: 12px;
        }
        background-color: #aaa;
      }
      &.no-payed{
        i{
          background: url('../../../../common/assets/img/status_bad.png') no-repeat #ff3333;
          width: 16px;
          height: 12px;
        }
        background-color: #ff3333;
      }
      &.booked{
        i{
          background: url('../../../../common/assets/img/status_bad.png') no-repeat #ff9800;
          width: 16px;
          height: 12px;
        }
        background-color: #ff9800;
      }

    }
    .order-msg{
      color: #aaa;
      font-size: 11px;
      line-height: 12px;
    }
    .order-discount{
      padding-bottom: 1rem;
      color: #aaa;
      font-size: 11px;
      line-height: 12px;
    }
    .order-cancel{
      display: flex;
      // justify-content: center;
      align-items: center;
      margin-top: 1rem;
      i {
        background: url('../../../../common/assets/img/cancel_red.png') no-repeat;
        width: 15px;
        height: 8px;
      }
      .plus {
        font-size: 20px;
        padding-right: 5px;
        color: #0c9;
      }
      text-decoration: none;
      color: #aaa;
      font-size: 11px;
      line-height: 12px;
    }

  }
}
</style>
